import {DropdownInput, generateOptionsFromSchema, ValueInputRendererProps} from 'apstra-ui-common';
import {FC, useMemo} from 'react';
import type {JSONSchema7} from 'json-schema';

const StageWidgetValueColumnNameInput: FC<ValueInputRendererProps> = ({
  value, name, schema, required, disabled, onChange
}) => {
  const valueColumnOptions = useMemo(() => generateOptionsFromSchema(schema as JSONSchema7), [schema]);
  return (
    <ValueColumnNameInput
      options={valueColumnOptions}
      value={value}
      onChange={onChange}
      disabled={disabled}
      required={required}
      schema={schema}
      name={name}
    />
  );
};

export default StageWidgetValueColumnNameInput;

export const ValueColumnNameInput: FC<ValueInputRendererProps> = (props) =>
  <DropdownInput search fieldProps={{className: 'column-value-input'}} {...props} />;
